import React from "react";
import { Typography } from "@/components/Typography";

export const FeedbackHeader = ({ data }) => {
  const { title, subtitle } = data;
  return (
    <>
      {(title || subtitle) && (
        <div className="feedback-template__info">
          {title && (
            <div className="feedback-template__info-title">
              <Typography
                Tag="p"
                classname="u-semibold u-spacing-4"
              >
                {title}
              </Typography>
            </div>
          )}
          {subtitle && (
            <div className="feedback-template__info-description">
              <Typography
                Tag="p"
                classname="u-spacing-4"
              >
                {subtitle}
              </Typography>
            </div>
          )}
        </div>
      )}
    </>
  );
};
